import React, { useState, useEffect, useCallback } from 'react';
import {
  RACTextField,
  makeStyles,
  InputAdornment,
} from '@rentacenter/racstrap';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash/debounce';

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    // padding: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
  },
  searchField: {
    '& .MuiInputBase-root': {
      fontSize: '0.8rem',
      borderRadius: 8,
      minHeight: '36px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 12px',
    },
    '& .MuiFormLabel-root': {
      fontSize: '0.8rem',
    },
  },
}));

interface SearchNotesProps {
  onSearch?: (query: string) => void;
  isSearching?: boolean;
}

/**
 * Component for searching notes
 */
export const SearchNotes: React.FC<SearchNotesProps> = ({
  onSearch,
  isSearching,
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState('');

  // Create debounced search function to avoid too many API calls
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((q: string) => {
      if (onSearch) {
        onSearch(q);
      }
    }, 500),
    [onSearch]
  );

  // Effect to trigger search when query changes
  useEffect(() => {
    if (onSearch) {
      debouncedSearch(query);
    }
    // Cancel debounced call on cleanup
    return () => {
      debouncedSearch.cancel();
    };
  }, [query, debouncedSearch, onSearch]);

  // Handle search input change
  const handleQueryChange = (value: string) => {
    setQuery(value);
  };

  return (
    <div className={classes.searchContainer}>
      <RACTextField
        className={classes.searchField}
        // label='Search notes'
        variant="outlined"
        fullWidth
        value={query}
        onChange={handleQueryChange}
        disabled={isSearching}
        placeholder="Search notes..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};
